import { CellContext } from '@tanstack/react-table';
import clsx from 'clsx';
import { CSSProperties, ReactNode } from 'react';
import { Stack } from 'src/core/ui';

import { BaseCell, BaseCellProps } from './BaseCell';
import * as styles from './SvgCell.css';

export interface SvgCellProps<TData = unknown>
  extends Omit<BaseCellProps, 'children'> {
  context?: CellContext<TData, ReactNode | ReactNode[]>;
  value?: ReactNode | ReactNode[];
  wrapperClassName?: string;
  svgWrapperStyle?: CSSProperties;
}

export function SvgCell<TData>({
  context,
  value,
  wrapperClassName,
  svgWrapperStyle,
  ...props
}: SvgCellProps<TData>) {
  const svgs = value ?? context?.getValue();
  const align = context?.column.columnDef.meta?.align ?? props.align;

  if (!svgs) {
    return <BaseCell align={align} {...props} />;
  }

  const svgArray = Array.isArray(svgs) ? svgs : [svgs];

  return (
    <BaseCell align={align} {...props}>
      <Stack gap={'s'}>
        {svgArray.map((svg, index) => (
          <div
            key={index}
            className={clsx(styles.svgWrapper, wrapperClassName)}
            style={svgWrapperStyle}
          >
            {svg}
          </div>
        ))}
      </Stack>
    </BaseCell>
  );
}
